import { useQuery } from 'react-query';

import { YearClosure, YearClosureTableData } from '../types';

import { getYearClosure } from 'RestAPIs/admin';

const convertYearClosureRequest = (
  data: YearClosure
): YearClosureTableData[] => {
  return [
    {
      year: data.openYear,
      isOpenedStatus: true,
      unrealizedDuties: data.unRealizedDutyLinesOpenYear
    },
    {
      year: data.lastClosedYear,
      isOpenedStatus: false,
      unrealizedDuties: 0
    }
  ];
};

export const useGetTableData = () => {
  const { data, isFetching } = useQuery(
    ['yearClosure', 'list'],
    async () => {
      const { data } = await getYearClosure();
      return data;
    },
    {
      select: convertYearClosureRequest
    }
  );

  return { data, isFetching };
};
